import { render } from "./Orientacion.vue?vue&type=template&id=da19a9f4&scoped=true"
import script from "./Orientacion.vue?vue&type=script&lang=js"
export * from "./Orientacion.vue?vue&type=script&lang=js"

import "./Orientacion.vue?vue&type=style&index=0&id=da19a9f4&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da19a9f4"]])

export default __exports__